import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs'


@Injectable()
export class RiskEvalutionExecutionService{

  public commentsEvent$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  commentsObservable = this.commentsEvent$.asObservable();

  public usersExecutionFormEvent$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  usersExecutionObservable = this.usersExecutionFormEvent$.asObservable();


    constructor(private http: HttpClient) {
    }

    getEvaluationFormDetails(formId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationForm/' + formId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

        getRiskProbabilityList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getRiskProbabilityList' )
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

        initializeRiskProbabilityMaster(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/initializeRiskProbabilityMaster' )
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }


    getRiskOwners(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getRiskOwnerList' )
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

    // to get Assinged Form Details
    getAssignedEvalutionFormDetails(assignedFormId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getAssignedEvaluationForm/' + assignedFormId)
        .toPromise()
        .then(response => {
            return Promise.resolve(response)
        })
    }


    getEvaluationReviewFormDetails(userId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getReviewEvaluationFormListById/' + userId)
        .toPromise()
        .then(response => {
            return Promise.resolve(response)
        })
    }

    
    // to answer evaluation question execution 
    answerEvaluationFormExecution(answerObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/executeEvaluationFormAnswer' , answerObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

    submitEvaluationExecutionForm(formId): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/submitEvaluationExecutionForm' , formId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

    submitComments(commentsObject): Promise<any> {
        return this.http.put(environment.clientUrl + 'riskEvaluationMaster/commentEvaluation' , commentsObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    } 


     // to get Assinged Form Details
    getAssignedEvalutionFormDetailsByArrayOfId(IdObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/getAssignedEvaluationFormByIds', IdObject)
        .toPromise()
        .then(response => {
            return Promise.resolve(response)
        })
    }

    submitOverAllEvaluationExecutionForm(objectArray): Promise<any> {
        return this.http.put(environment.clientUrl + 'riskEvaluationMaster/updateOverAllEvaluationExecutionFormStatus' , objectArray)
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }
 

    // to answer evaluation question execution 
    answerOverallEvaluationFormExecution(answerObject): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/submitOverallAnswersByEvaluationFormId' , answerObject)
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

}
